import { render, staticRenderFns } from "./Checkstand.vue?vue&type=template&id=6a120c0e&scoped=true&"
import script from "./Checkstand.vue?vue&type=script&lang=ts&"
export * from "./Checkstand.vue?vue&type=script&lang=ts&"
import style0 from "./Checkstand.vue?vue&type=style&index=0&id=6a120c0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a120c0e",
  null
  
)

export default component.exports